import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const labels = ['여성', '남성'];

export const options = {
    responsive: true,
    plugins: {
        legend: {
            display: false // 범례 표시
        },
        tooltip: {
            callbacks: {
                label: function(context) {
                    let label = context.label || ''; // 데이터셋의 라벨 가져오기
                    if (label) {
                        label += ': '; // 라벨과 데이터 사이에 콜론 추가
                    }
                    if (context.parsed !== null) {
                        label += context.parsed + '%'; // 데이터 값에 퍼센트 추가
                    }
                    return label;
                }
            }
        }
    }
};

const AdminMobileDoughChart = ({ genders }) => {
    //
    // genders 객체가 유효한 값인지 확인하고, 그에 따라 데이터 설정
    const data = {
        labels,
        datasets: [
            {
                label: '구매자 통계(단위 : %)',
                data: genders ? [Math.round(genders.femaleRatio * 100), Math.round(genders.maleRatio * 100)] : [50, 50],
                backgroundColor: [
                    '#FFA6A6',
                    '#A5D4FD',
                ],
                borderColor: [
                    'transparent',
                    'transparent',
                ],
                borderWidth: 1,
            },
        ],
    };

    return <Doughnut data={data} options={options} />;
};

export default AdminMobileDoughChart;